module.exports = __webpack_public_path__ + "static/media/2-3.1bce9f50.png";